<template>
    <div class="section-footer" :class="{'single': buttons.length === 1}">
        <button
            class="button"
            :class="button.class"
            v-for="button in buttons"
            :disabled="button.disabled"
            @click.prevent="emit(button.event)">
            {{ button.label }}
        </button>
    </div><!-- end.section-footer -->
</template>
<script>
    export default {
        props: ['buttons'],
        methods: {
            emit(type) {
                this.$emit(type);
            }
        }
    }
</script>